// removed by extract-text-webpack-plugin
module.exports = {"card":"GroupSession__card___3wMBb","input-radio":"GroupSession__input-radio___3Qgh2"};